import { MissionToExternalStaff } from '../../lib/types/models/mission-to-external-staff/mission-to-external-staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getAffectedExternalStaffs(id: number) {
  return restApiClient
    .url(constructApiUrl(API.missions.getAffectedExternalStaffs.url, { id }))
    .get<MissionToExternalStaff[]>()
}
